import { baseClientEnvironment } from "./environment.client.base";

export const clientEnvironment = {
  ...baseClientEnvironment
};
